module.exports = __webpack_public_path__ + "static/img/3x1.9b134ab7.svg";